/* istanbul ignore file */

import { createUseStyles } from '@glu/theming';

export default createUseStyles(({ spacing: { unit } }) => ({
  wrapper: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 6.25 * unit,
    marginBottom: 6.25 * unit
  }
}));
